import ValidateModel from './validateModel'

export default ValidateModel
